// extracted by mini-css-extract-plugin
module.exports = {"header":"RatingsAndReviewsHeader_header__3hzb_","ratingTitle":"RatingsAndReviewsHeader_ratingTitle__NMY05","ratingLabel":"RatingsAndReviewsHeader_ratingLabel__1oSFm"};